import * as actionTypes from "../ActionTypes";
import { initialVersionDetails } from "../../constants/bible";

const INITIAL = {
  bibleLanguage: 17045,
  bibleLanguageName: "English",
  bibleVersion: "ENGESV",
  versionDetails: initialVersionDetails ?? {},
  versionDetailsLoading: false,
  bookChapterDetails: [],
  countryLanguages: [],
  allBibleLanguages: [],
  bookChapterDetailsLoading: true,
  activeSearchTab: "Language",
  allJournals: []
};

const bibleReducer = (state = INITIAL, action) => {
  switch (action.type) {
    case actionTypes.SET_BIBLE_LANGUAGE:
      return {
        ...state,
        bibleLanguage: action.payload,
      };
    case actionTypes.SET_BIBLE_LANGUAGE_NAME:
      return {
        ...state,
        bibleLanguageName: action.payload,
      };
    case actionTypes.SET_BIBLE_COUNTRY_LANGUAGES:
      return {
        ...state,
        countryLanguages: action.payload,
      };
    case actionTypes.SET_BIBLE_VERSION:
      return {
        ...state,
        bibleVersion: action.payload,
      };
    case actionTypes.SET_VERSION_DETAILS:
      return {
        ...state,
        versionDetails: action.payload,
      };
    case actionTypes.SET_VERSION_DETAILS_LOADING:
      return {
        ...state,
        versionDetailsLoading: action.payload,
      };
    case actionTypes.SET_BOOK_CHAPTER_DETAILS:
      return {
        ...state,
        bookChapterDetails: action.payload,
      };
    case actionTypes.SET_BOOK_CHAPTER_DETAILS_LOADING:
      return {
        ...state,
        bookChapterDetailsLoading: action.payload,
      };
    case actionTypes.SET_ACTIVE_SEARCH_TAB:
      return {
        ...state,
        activeSearchTab: action.payload,
      };
    case actionTypes.SET_ALL_BIBLE_LANGUAGES:
      return {
        ...state,
        allBibleLanguages: action.payload,
      };
    case actionTypes.SET_ALL_JOURNALS:
      return {
        ...state,
        allJournals: action.payload,
      };
      // Action type handler in reducer
case actionTypes.GET_JOURNALS:
  // Note: GET_JOURNALS doesn't seem to have a SET action in your reducer
  // You might need to add a SET_JOURNALS action if you want to store journals in state
  return state;

// You might need to add this action type handler if you want to store journals:
case actionTypes.SET_JOURNALS:
  return {
    ...state,
    journals: action.payload, // You'll need to add 'journals' to INITIAL state
  };
    default:
      return state;
  }
};

export default bibleReducer;
